import type { ReactionModel } from './Reactions.types';
import { reactionsState } from './reactionsState';

export const addReactionToSharedState = (reaction: ReactionModel) => {
  if (!reactionsState.value.reactions[reaction.idModel]) {
    reactionsState.setValue({
      ...reactionsState.value,
      reactions: {
        ...reactionsState.value.reactions,
        [reaction.idModel]: [],
      },
    });
  }

  reactionsState.setValue({
    ...reactionsState.value,
    reactions: {
      ...reactionsState.value.reactions,
      [reaction.idModel]: [
        ...reactionsState.value.reactions[reaction.idModel],
        reaction,
      ],
    },
  });
};
